import cn from 'classnames';
import styles from './BlockInfo.module.scss';
import { ReactNode } from 'react';
import { TitleVariant } from '@/types';
import { Title, TitleFont } from '../Title';

type BlockInfoProps = {
  className?: string;
  contentClass?: string;
  title?: string;
  link?: {
    text: string;
    url: string;
  };
  children: ReactNode;
  accent?: boolean;
  titleFont?: TitleFont;
  titleVariant?: TitleVariant;
  titleClass?: string;
};

export function BlockInfo({
  className,
  children,
  title,
  contentClass,
  accent,
  titleFont,
  titleVariant,
  titleClass,
}: BlockInfoProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.accent]: accent,
    },
    className,
  );
  const contentClassName = cn(styles.content, contentClass);

  return (
    <div className={wrapperClassName}>
      {title && (
        <div className={styles.heading}>
          <Title
            text={title}
            variant={titleVariant}
            className={cn(styles.title, titleClass)}
            font={titleFont}
          />
        </div>
      )}
      <div className={contentClassName}>{children}</div>
    </div>
  );
}
